const R = (w => w && w.__APP_CONFIG__)(typeof window !== "undefined" ? window : {});
export const API_BASE_URL      = R?.API_BASE_URL      ?? import.meta.env.VITE_API_BASE_URL;
export const PY_API_BASE_URL   = R?.PY_API_BASE_URL   ?? import.meta.env.VITE_PYTHON_API_BASE_URL;
export const BASE_PATH_RUNTIME = R?.BASE_PATH         ?? import.meta.env.VITE_BASE_PATH ?? "/";
export const EXTERNAL_HTTP_PORT = R?.EXTERNAL_HTTP_PORT ?? import.meta.env.VITE_EXTERNAL_HTTP_PORT ?? "80";
export const EXTERNAL_HTTPS_PORT = R?.EXTERNAL_HTTPS_PORT ?? import.meta.env.VITE_EXTERNAL_HTTPS_PORT ?? "443";
export const INDEXED_DB_VERSION = R?.INDEXED_DB_VERSION ?? import.meta.env.VITE_INDEXED_DB_VERSION ?? "1";

export const AUTH_MODE = R?.AUTH_MODE ?? import.meta.env.VITE_AUTH_MODE ?? "legacy";

export const KEYCLOAK_URL =
(R?.KEYCLOAK_URL ?? import.meta.env.VITE_KEYCLOAK_URL ?? "").replace(/\/+$/, "");

export const KEYCLOAK_REALM =
  R?.KEYCLOAK_REALM ?? import.meta.env.VITE_KEYCLOAK_REALM ?? "";

export const KEYCLOAK_FRONTEND_CLIENT_ID =
  R?.KEYCLOAK_FRONTEND_CLIENT_ID ?? import.meta.env.VITE_KEYCLOAK_FRONTEND_CLIENT_ID ?? "";

